// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopBankCardControllerActivateBankCardData } from './EshopBankCardControllerActivateBankCardData.gen';
import type { EshopBankCardControllerActivateBankCardErrors } from './EshopBankCardControllerActivateBankCardErrors.gen';
import type { EshopBankCardControllerActivateBankCardResponses } from './EshopBankCardControllerActivateBankCardResponses.gen';
import type { EshopBankCardControllerBlockBankCardData } from './EshopBankCardControllerBlockBankCardData.gen';
import type { EshopBankCardControllerBlockBankCardErrors } from './EshopBankCardControllerBlockBankCardErrors.gen';
import type { EshopBankCardControllerBlockBankCardResponses } from './EshopBankCardControllerBlockBankCardResponses.gen';
import type { EshopBankCardControllerGetCustomerBankCardsData } from './EshopBankCardControllerGetCustomerBankCardsData.gen';
import type { EshopBankCardControllerGetCustomerBankCardsErrors } from './EshopBankCardControllerGetCustomerBankCardsErrors.gen';
import type { EshopBankCardControllerGetCustomerBankCardsResponses } from './EshopBankCardControllerGetCustomerBankCardsResponses.gen';
import type { EshopBankCardControllerRemoveBankCardData } from './EshopBankCardControllerRemoveBankCardData.gen';
import type { EshopBankCardControllerRemoveBankCardErrors } from './EshopBankCardControllerRemoveBankCardErrors.gen';
import type { EshopBankCardControllerRemoveBankCardResponses } from './EshopBankCardControllerRemoveBankCardResponses.gen';
import type { Options } from './Options.gen';

export class EshopBankCardController {
    /**
     * Get bank card info list for the given customer.
     */
    public static getCustomerBankCards<ThrowOnError extends boolean = false>(options: Options<EshopBankCardControllerGetCustomerBankCardsData, ThrowOnError>) {
        return (options.client ?? client).get<EshopBankCardControllerGetCustomerBankCardsResponses, EshopBankCardControllerGetCustomerBankCardsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/bank-card/{customerId}',
            ...options
        });
    }
    
    /**
     * Block active bank card.
     */
    public static blockBankCard<ThrowOnError extends boolean = false>(options: Options<EshopBankCardControllerBlockBankCardData, ThrowOnError>) {
        return (options.client ?? client).put<EshopBankCardControllerBlockBankCardResponses, EshopBankCardControllerBlockBankCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/bank-card/{id}/block',
            ...options
        });
    }
    
    /**
     * Activate blocked bank card.
     */
    public static activateBankCard<ThrowOnError extends boolean = false>(options: Options<EshopBankCardControllerActivateBankCardData, ThrowOnError>) {
        return (options.client ?? client).put<EshopBankCardControllerActivateBankCardResponses, EshopBankCardControllerActivateBankCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/bank-card/{id}/activate',
            ...options
        });
    }
    
    /**
     * Remove tokenized or blocked bank card.
     */
    public static removeBankCard<ThrowOnError extends boolean = false>(options: Options<EshopBankCardControllerRemoveBankCardData, ThrowOnError>) {
        return (options.client ?? client).delete<EshopBankCardControllerRemoveBankCardResponses, EshopBankCardControllerRemoveBankCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/bank-card/{id}',
            ...options
        });
    }
}
